module.exports = __webpack_public_path__ + "static/media/pass-hide.90c77f2a.svg";